import {
  DiscountTypes,
  IProduct,
} from "@/api/AppApi/services/home/interfaces/IProduct";
import ProductCard from "./product-box-helpers/ProductCard";
import ProductBoxImage from "./product-box-helpers/product-box-image/ProductBoxImage";
import ProductName from "./product-box-helpers/ProductName";
import ProductDescription from "./product-box-helpers/ProductDescription";
import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import ProductBrand from "./product-box-helpers/ProductBrand";
import ProductClick from "./product-box-helpers/ProductClick";
import { Config_Customize } from "@/api/AppApi/services/home/interfaces/ICategory";
import { ITheme } from "@/api/AppApi/services/company/interfaces/ICompany";
import ProductBoxTailAndRate from "./ProductBoxTailAndRate";
import EventCustomData from "./product-box-helpers/event/EventCustomData";
import { getIsService } from "./product-box-helpers/functions";
import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import StockAlertMessage from "./product-box-helpers/stock-alert-message";
interface Props extends IProduct {
  scrollableTabs: boolean;
  size: Size;
  theme: ITheme;
  priority: boolean;
  Customize?: Config_Customize;
  isGrid: boolean;
  showCustomEventData?: boolean;
}

const ProductBox = (props: Props) => {
  const {
    theme,
    size,
    scrollableTabs,
    isGrid,
    Customize,
    discount,
    thumbnail_url,
    slug,
    is_new,
    has_discount,
    discount_amount,
    discount_type,
    priority,
    name,
    description,
    brand,
    images,
    preview_type,
    custom_data,
    price,
    price_without_discount,
    selling_prices,
    showCustomEventData,
    quantity_on_hand,
    min_quantity_in_cart,
  } = props;
  const {
    show_brand,
    show_description,
    show_name,
    show_low_stock_alert,
    min_stock_quantity_to_show_alert,
  } = theme?.components?.product ?? {};
  // const getCart = useGetCartQuery();

  // const cartItems = getCart?.data?.result?.items;

  // const currentProductQuantityInCart =
  //   cartItems
  //     ?.filter((item) => item.inner_id === props.id)
  //     .reduce((prev, current) => prev + current.quantity, 0) ?? 0;

  const isService = getIsService(preview_type as ProductPreviewTypes);
  const viewDetails =
    isService ||
    props.has_required_addons ||
    props.is_configurable ||
    props.has_term_and_condition ||
    props.has_configurable_parent ||
    props.has_required_fields ||
    (!!props.units.length && theme?.components?.product.show_all_product_units);

  const outOfStock =
    (quantity_on_hand <= 0 ||
      (!!min_quantity_in_cart && min_quantity_in_cart > quantity_on_hand)) &&
    !viewDetails;

  const showMinStockQuantityMsg =
    show_low_stock_alert &&
    quantity_on_hand <= min_stock_quantity_to_show_alert &&
    !outOfStock &&
    quantity_on_hand > 0;
  return (
    <ProductCard
      size={size}
      theme={theme}
      scrollableTabs={scrollableTabs}
      isGrid={isGrid}
    >
      <ProductClick slug={slug} isEvent={scrollableTabs} Customize={Customize}>
        <ProductBoxImage
          theme={theme}
          discount={discount}
          scrollableTabs={scrollableTabs}
          src={thumbnail_url}
          size={size}
          is_new={is_new}
          has_discount={has_discount ?? discount_amount > 0}
          discount_type={discount_type ?? DiscountTypes.rate}
          discount_amount={discount_amount}
          priority={priority}
          images={images}
          outOfStock={outOfStock}
        />
      </ProductClick>
      <div className="product-info">
        {show_name && (
          <ProductClick slug={slug} isEvent={scrollableTabs}>
            <ProductName name={name} isEvent={preview_type === "event"} />
          </ProductClick>
        )}
        {preview_type === "event" && showCustomEventData && (
          <EventCustomData
            {...custom_data!}
            price={price}
            price_without_discount={price_without_discount}
            special_prices={selling_prices}
          />
        )}
        {show_description && (
          <ProductDescription size={size} description={description ?? ""} />
        )}
        {(show_brand || show_low_stock_alert) && (
          <div className="product-brand-containter">
            {show_brand && <ProductBrand size={size} brand={brand} />}
            {showMinStockQuantityMsg ? (
              <StockAlertMessage minStockQuantity={quantity_on_hand} />
            ) : (
              <div style={{ height: 10 }} />
            )}
          </div>
        )}
        <ProductBoxTailAndRate {...props} />
      </div>
    </ProductCard>
  );
};

export default ProductBox;
